import React, { Component } from 'react';
import withRouter from '../../helpers/withWrapper'

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import levelPrices from "../../services/levelPrice";
import getWallet from "../../services/wallet";
import getContract, { getGlobalRewardContract, getOwnerContract } from "../../services/contract";

import moment from "moment";
import { ethers } from 'ethers';
import {
  AiFillAccountBook,
  AiFillCopy,
  AiOutlinePaperClip,
  AiOutlineShareAlt,
  AiFillDollarCircle,
  AiFillMoneyCollect,
} from "react-icons/ai";

class Pools extends Component {
    state = {
        userAddress: "",
        isWalletConnected: false,
        isAuthorized: false,
        eligibility: 0,
        userId: 0,
        shareInfos: [],
        currentPoolId: 0,
        totalShares: 0,
        timeLeftToClaim: '15 d'
    }

    constructor(props) {
        super(props);
        if(props.router.params.id) {
            this.state.userId = props.router.params.id;
        } else {
            this.state.userId = 1;
        }
        this.props.onSetUserId(this.state.userId);
    }


    async componentDidMount() {
      try {
        

        const promise = this.initializeState();
            await toast.promise(
              promise,
                {
                  pending: 'Fetching Giver Rewards',
                  success: 'Giver Rewards Fetched! 👌',
                  error: 'Fetching Giver Rewards failed'
                }
            )
      } catch (error) {
        console.log(error);
      }
    }

    async initializeState() {
      const wallet = await getWallet();
      const matrix = await getContract();
      const contract = await getGlobalRewardContract();

      const userAddress = await matrix.userAddressByID(this.state.userId);

      const currentPoolId = ethers.BigNumber.from(await contract.currentPoolNumber()).toNumber();

      // const timeLeftInEpoch = ethers.BigNumber.from(
      //   await contract.getCurrentPoolTimeLeft()
      // ).toNumber();

      const currentPoolStartTimeInEpoch_inSec = ethers.BigNumber.from(await contract.poolStartTime(currentPoolId)).toNumber();

      // const claimPeriodInEpoch_inSec = ethers.BigNumber.from(await contract.claimPeriod()).toNumber();
      const poolEndTimeInEpoch_inSec = ethers.BigNumber.from(await contract.poolEndTime(currentPoolId)).toNumber();
      
      const claimPeriod_inMiliSec = (poolEndTimeInEpoch_inSec) * 1000;

      const totalSharesBN = await contract.totalShares();
      const totalShares = ethers.BigNumber.from(totalSharesBN).toNumber();

      const amountPerPoolBN = await contract.amountPerPool(currentPoolId);
      const amountPerPool = parseFloat(ethers.utils.formatUnits(amountPerPoolBN, "mwei")).toFixed(2);

      const sharesPerPoolBN = await contract.totalSharesPerPool(currentPoolId);
      const sharesPerPool = ethers.BigNumber.from(sharesPerPoolBN).toNumber();

      const isEligible = await contract.isEligible(this.state.userId);

      const eligibility = ethers.BigNumber.from(await contract.userClaimEligibility(this.state.userId)).toString();

      let totalShareIncomeEarned = 0.00;
      let totalShareIncomeIpEarned = 0.00;
      if(isEligible) {
        const shareIncome = await contract.getAllShareIncome(this.state.userId);
        totalShareIncomeEarned = parseFloat(ethers.utils.formatUnits(shareIncome[0], "mwei")).toFixed(2);
        totalShareIncomeIpEarned = parseFloat(ethers.utils.formatUnits(shareIncome[1], "mwei")).toFixed(2);
      }

      // const totalIncomeUnClaimed = await contract.getAllUnClaimedShareIncome(this.state.userId)

      let shareInfos = [];
      if(isEligible) {
        for(let i = 1; i <= currentPoolId; i++) {
          const shareInfoResponse = await contract.getShareInfo(this.state.userId, i);

          const poolId = i;
          const shareIncome = parseFloat(ethers.utils.formatUnits(shareInfoResponse[0], "mwei")).toFixed(2);
          const userShare = ethers.BigNumber.from(shareInfoResponse[1]).toString();

          const totalShareInPool = ethers.BigNumber.from(shareInfoResponse[2]).toString();
          const startTime = this.getDateInMiliSecFromSec(
            ethers.BigNumber.from(shareInfoResponse[3]).toNumber()
          ).toDateString();
          const endTime = this.getDateInMiliSecFromSec(
            ethers.BigNumber.from(shareInfoResponse[4]).toNumber()
          ).toDateString();
          const claimable = shareInfoResponse[5];
          console.log(claimable);
          
          const isClaimed = shareInfoResponse[6];
          
          const isEligibleForPool = shareInfoResponse[7];
          const shareIpIncome = parseFloat(ethers.utils.formatUnits(shareInfoResponse[8], "mwei")).toFixed(2);
          
          const amountPerPool = parseFloat(ethers.utils.formatUnits(await contract.amountPerPool(poolId), "mwei")).toFixed(2);

          if(isEligibleForPool) {
            shareInfos.push({poolId, shareIncome, userShare, totalShareInPool, startTime, endTime, claimable, isClaimed, amountPerPool, shareIpIncome});
          }

          // const oldShares = shareInfos.filter(sh => sh.poolId <= 3);
          // if(oldShares.length == 3) {
          //   shareInfos[2].startTime = 'Tue Feb 07 2023';
          //   shareInfos[2].endTime = 'Wed Feb 22 2023';

          //   shareInfos[1].startTime = 'Mon Jan 23 2023';
          //   shareInfos[1].endTime = 'Tue Feb 07 2023';

          //   shareInfos[0].startTime = 'Sun Jan 08 2023';
          //   shareInfos[0].endTime = 'Mon Jan 23 2023';
          // } else if (oldShares.length == 2) {
          //   shareInfos[1].startTime = 'Tue Feb 07 2023';
          //   shareInfos[1].endTime = 'Wed Feb 22 2023';

          //   shareInfos[0].startTime = 'Mon Jan 23 2023';
          //   shareInfos[0].endTime = 'Tue Feb 07 2023';
          // } else if (oldShares.length == 1) {
          //   shareInfos[0].startTime = 'Tue Feb 07 2023';
          //   shareInfos[0].endTime = 'Wed Feb 22 2023';
          // } 
        }
      }
      
      const userCurrentPoolShares = ethers.BigNumber.from(
        await contract.getCorrectUserShareInPool(this.state.userId, currentPoolId)
      ).toNumber();
      
      let currentPoolIncome = 0.00;
      if(isEligible) {
        currentPoolIncome = +shareInfos[shareInfos.length-1].shareIncome;
      }

      const sharePercent = (userCurrentPoolShares / totalShares * 100).toFixed(2);

      // const userTotalShares = ethers.BigNumber.from(
      //   await constract.userTotalShares(this.state.userId)
      // ).toString();

      shareInfos = shareInfos.sort((a, b) => b.poolId - a.poolId);

      let timeLeftToClaim = '';
      
      const startDate = Date.now();
      let formatDate = moment.duration(claimPeriod_inMiliSec - startDate)
      
      if (formatDate && (claimPeriod_inMiliSec >= startDate)) {
          if ( formatDate.months() > 0 ) {
              timeLeftToClaim = `${Math.round(formatDate.asDays())}d ${formatDate.hours()}h ${formatDate.minutes()}m`
          }
          else {
              timeLeftToClaim = `${formatDate.days()}d ${formatDate.hours()}h ${formatDate.minutes()}m`
          }
      } else {
        timeLeftToClaim = "0d 0h 0m"
      }

      this.setState({totalShares, currentPoolId, amountPerPool, userCurrentPoolShares, currentPoolIncome, eligibility, 
        timeLeftToClaim, sharePercent, shareInfos, totalShareIncomeEarned, totalShareIncomeIpEarned, userAddress})
    }

    async claimReward(poolId) {
      
      try {
        const wallet = await getWallet();
          if(wallet.isReadOnly) {
              alert("Please connect your wallet");
              return;
          }
          
          if(this.state.userId == 1) {
            const contract = await getOwnerContract();
            const claimRewardPromise = contract.claimGlobalRewards(poolId);
            await toast.promise(
              claimRewardPromise,
                {
                  pending: 'Claiming Rewards in progress',
                  success: 'Rewards Sent to Owner Contract!',
                  error: 'Claim Rewards failed'
                }
            )
          } else {
            const contract = await getGlobalRewardContract();
            // const claimRewardPromise = contract.claimRewards(this.state.userId, poolId, 
            //   {gasPrice: ethers.utils.parseUnits(wallet.maxFeePerGas.toString(), 'gwei')});
            const claimRewardPromise = contract.claimRewards(this.state.userId, poolId);
            await toast.promise(
              claimRewardPromise,
                {
                  pending: 'Claiming Rewards in progress',
                  success: 'Rewards sent to your wallet! 👌',
                  error: 'Claiming Rewards failed'
                }
            )
          }

          // await this.initializeState();

          const promise = this.initializeState();
            await toast.promise(
              promise,
                {
                  pending: 'Fetching Giver Rewards',
                  success: 'Giver Rewards Fetched! 👌',
                  error: 'Fetching Giver Rewards failed'
                }
            )
      } catch (error) {
        if(error.reason) {
          alert(`${error.reason}`)
        } else {
          alert(error.message)
        }
      }
    }

    getDateInMiliSecFromSec(x) {
        const myDate = new Date(x * 1000);
        return myDate;
     }

    render() {


        return (
          <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
            {/* <ToastContainer position="bottom-right" /> */}
            <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
              {/* Top Panel, Matrix levels and all activies inside below div */}
              <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                <div
                  className="grid grid-cols-3 dashboard-copy-grid items-center"
                  style={{ gap: "10px" }}
                >
                  <div className="col-span-2 grid-left">
                    <div className="grid grid-cols-2" style={{ gap: "10px" }}>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          Total shares
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.totalShares}</h2>
                          <AiFillAccountBook style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          Total amount in current pool
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.amountPerPool} USDT</h2>
                          <AiFillDollarCircle style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                    </div>
                    <div
                      className="grid grid-cols-2"
                      style={{ gap: "10px", marginTop: "10px" }}
                    >
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          My shares
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.userCurrentPoolShares}</h2>
                          <AiFillAccountBook style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          Current pool income
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.currentPoolIncome} USDT</h2>
                          <AiFillDollarCircle style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          Claim Eligibility
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.eligibility} times</h2>
                          <AiFillDollarCircle style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          USDT Earnings
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.totalShareIncomeEarned} USDT</h2>
                          <AiFillDollarCircle style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          IP Earnings
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.totalShareIncomeIpEarned} USDT</h2>
                          <AiFillDollarCircle style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                      <div
                        className="col-span-1 border p-5 rounded-md"
                        style={{
                          borderColor: "rgb(255, 218, 71)",
                          background: " rgba(112, 100, 0, 0.25)",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          Time left to claim current pool
                        </h3>
                        <div className="flex items-center justify-between ">
                          <h2 style={{ fontSize: "18px" }}>{this.state.timeLeftToClaim}</h2>
                          <AiFillAccountBook style={{ fontSize: "30px" }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 grid-right p-5 rounded-md flex flex-col items-center">
                    <img
                      style={{ width: "70px", height: "70px" }}
                      src="/logo/Logo_ Front (small_size).png"
                      className="light"
                      alt=""
                    />
                    <h2
                      className="mt-5 mb-3"
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      ID # {this.state.userId}
                    </h2>
                    {/* <AiOutlineShareAlt style={{ fontSize: "20px" }} /> */}
                    {/* <span className="py-3">Class on Magestic</span> */}
                    <div
                      className="border p-4 flex items-center rounded-md"
                      style={{
                        borderColor: "rgb(255, 218, 71)",
                        columnGap: "5",
                        borderStyle: "dashed",
                      }}
                    >
                      <h2
                      className="mt-5 mb-3"
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      Current Running Pool # {this.state.currentPoolId}
                    </h2>
                      {/* <span>{this.state.userAddress != ""
                        ? this.state.userAddress.slice(0, 4) +
                        "..." +
                        this.state.userAddress.slice(
                          this.state.userAddress.length - 4,
                          this.state.userAddress.length
                        )
                        : ""}</span> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* Table View below */}
              <h1
                style={{
                  fontSize: "25px",
                  marginTop: "40px",
                  marginBottom: "20px",
                }}
              >
                Global Rewards Pools History
              </h1>
              <div className="sm:rounded-none z-10 flex flex-1 flex-col w-full flex-col rounded overflow-hidden h-full min-h-90 sm:max-h-3/4">
                <div className="overflow-auto">
                  <table className="min-w-max w-full table-auto border-white-100">
                    <thead>
                      <tr className="text-white-500 text-xs border-b border-white-100">
                        <th className="p-4 text-left font-normal sm:p-3 ">
                          Pool No
                        </th>
                        <th className="p-4 text-left font-normal sm:p-3">
                          Start Date
                        </th>
                        <th className="p-4 text-left font-normal sm:p-3">
                          End Date
                        </th>
                        <th className="p-4 text-left font-normal sm:p-3">
                          Income
                        </th>
                        <th className="p-4 text-right font-normal sm:p-3">
                          Share in pool
                        </th>
                        <th className="p-4 text-right font-normal sm:p-3">
                          Total pool amount
                        </th>
                        <th className="p-4 text-right font-normal sm:p-3">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 text-sm font-light align-baseline">
                      {this.state.shareInfos.map((a, index) => {
                        return (
                          <tr
                            key={index}
                            className="border-b border-blue-100 last:border-none"
                          >
                            <td style={{border: 'none'}} className=" p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white-500 text-sm ">
                                {a.poolId}
                              </div>
                            </td>

                            <td style={{border: 'none'}} className="p-2 text-left whitespace-nowrap sm:p-3">
                              <div
                                className="flex items-left justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                              >
                                {a.startTime}
                              </div>
                            </td>
                            <td style={{border: 'none'}} className="p-2 text-left whitespace-nowrap sm:p-3">
                              <div
                                className="flex items-center justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                              >
                                {a.endTime}
                              </div>
                            </td>

                            <td style={{border: 'none'}} className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-left ">
                                {a.shareIncome} USDT
                              </div>
                            </td>
                            <td style={{border: 'none'}} className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-right ">
                                {a.userShare}
                              </div>
                            </td>
                            <td style={{border: 'none'}} className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-right ">
                                {a.amountPerPool} USDT
                              </div>
                            </td>
                            {a.claimable && !a.isClaimed ? (
                              <td style={{border: 'none'}} className="text-right whitespace-nowrap">
                                <div className="text-white text-sm text-right ">
                                  <button
                                    onClick={() => this.claimReward(a.poolId)}
                                    className="button w-full lightBtn"
                                  >
                                    Claim
                                  </button>
                                </div>
                              </td>
                            ) : a.isClaimed ? (
                              <td style={{border: 'none'}} className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-white text-sm text-right ">
                                  Claimed
                                </div>
                              </td>
                            ) : (
                              <td style={{border: 'none'}} className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-white text-sm text-right "></div>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
        );
    }
}

export default withRouter(Pools);